import { create } from 'zustand';

export const useBiaStore = create((set) => ({
    data: [],
    overallData: [],
    loading: false,
    error: null,
    uniqueValues: {},
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 1,
        hasNextPage: false,
        hasPreviousPage: false,
        sortBy: null,
        sortOrder: 'desc'
    },
    overallPagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 1,
        hasNextPage: false,
        hasPreviousPage: false,
        sortBy: null,
        sortOrder: 'desc'
    },
    searchQuery: "",
    stats: null,
    selectedItem: null,
    isSubmitting: false,

    setData: (data) => set({ data }),
    setOverallData: (overallData) => set({ overallData }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    setPagination: (pagination) => set({ pagination }),
    setOverallPagination: (overallPagination) => set({ overallPagination }),
    setSearchQuery: (searchQuery) => set({ searchQuery }),
    setStats: (stats) => set({ stats }),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setIsSubmitting: (isSubmitting) => set({ isSubmitting }),

    // Additional setters for flexibility
    setBias: (data) => set({ data }),
    setItems: (data) => set({ data }),
    setPaginationData: (pagination) => set({ pagination }),

    clearError: () => set({ error: null }),
}));
